<template>
    <div>
        <b-form-input
            ref="inputField"
            :placeholder="placeholder"
            v-model="internalValue" 
            :maxlength="maxlength"
            :state="state"
            :disabled="disabled"
            :type="type"
            :autocomplete="autocomplete"
            :autofocus="autofocus"
            :aria-label="label"
        />
        <div style="color: #4d535e; font-size: 13px;" :aria-label="`${maxlength} characters allowed, ${maxlength - value.length} characters remaining`">
            <div aria-hidden="true">{{`${value.length} / ${maxlength}`}}</div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { maxLength } from 'vuelidate/lib/validators';

export default Vue.extend(
{
    props:
    {
        value: 
        {
            type: String,
            default: ''
        },
        maxlength: 
        {
            type: Number,
            default: 5000
        },
        placeholder: 
        {
            type: String,
            default: ''
        },
        state:
        {
            type: Boolean,
            default: undefined
        },
        disabled:
        {
            type: Boolean,
            default: undefined
        },
        type: 
        {
            type: String,
            default: undefined
        },
        autocomplete: 
        {
            type: String,
            default: undefined
        },
        autofocus:
        {
            type: Boolean,
            default: undefined
        },
        label:
        {
            type: String,
            default: ''
        }
    },
    computed: 
    {
        internalValue: 
        {
            get() 
            {
                return this.value;
            },
            set(newValue)
            {
                this.$emit('input', newValue);
            }
        }
    },
    methods:
	{
		focus()
		{
			this.$refs.inputField.focus();
        }
	}
});
</script>

<style lang="scss" scoped>

</style>